'use client'

import {useState} from "react";
import {EyeOutlined, EyeInvisibleOutlined} from "@ant-design/icons";
import {PasswordInputStyled, PasswordToggleIcon} from "@/components/UI/Form/Inputs/PasswordInput/PasswordInput.styled";

const PasswordInput = ({inputProps, ...props}) => {
    const [visible, setVisible] = useState(false);

    return (
        <PasswordInputStyled
            {...props}
            inputProps={{
                ...inputProps,
                type: visible ? 'text' : 'password',
                style: {paddingRight: 30, ...inputProps?.style}
            }}
            renderSuffix={() => (
                <PasswordToggleIcon onClick={() => setVisible((prevVisible) => !prevVisible)}>
                    {visible ? <EyeOutlined/> : <EyeInvisibleOutlined/>}
                </PasswordToggleIcon>
            )}
        />
    );
};

export default PasswordInput;